import { Upload } from "lucide-react";
import { useRef, useState } from "react";

interface Props {
  onFile: (file: File) => void | Promise<void>;
  accept?: string;
}

export function UploadDropzone({
  onFile,
  accept = ".md,.docx,.pdf,.html,.txt,.eml,.pptx,.xlsx",
}: Props) {
  const [hover, setHover] = useState(false);
  const inputRef = useRef<HTMLInputElement>(null);

  function handleFiles(files: FileList | null) {
    if (!files) return;
    for (const f of Array.from(files)) onFile(f);
  }

  return (
    <button
      type="button"
      onClick={() => inputRef.current?.click()}
      onDragOver={(e) => {
        e.preventDefault();
        setHover(true);
      }}
      onDragLeave={() => setHover(false)}
      onDrop={(e) => {
        e.preventDefault();
        setHover(false);
        handleFiles(e.dataTransfer.files);
      }}
      className={`w-full rounded-lg border-2 border-dashed p-12 text-center transition ${
        hover
          ? "border-(--accent-500) bg-(--accent-50)"
          : "border-(--border-strong) hover:bg-(--bg-hover)"
      }`}
    >
      <Upload className="mx-auto mb-3 text-(--text-tertiary)" size={40} />
      <p className="font-medium">Arrastra archivos o haz click para seleccionar</p>
      <p className="mt-1 text-xs text-(--text-tertiary)">
        Markdown, DOCX, PDF, HTML, EML, PPTX, XLSX · máx 50 MB cada uno
      </p>
      <input
        ref={inputRef}
        type="file"
        accept={accept}
        multiple
        className="hidden"
        onChange={(e) => {
          handleFiles(e.target.files);
          e.currentTarget.value = "";
        }}
      />
    </button>
  );
}
